import { i18n, type Messages } from '@lingui/core';
import { storage } from 'noddi-util';

const FALLBACK_LOCALE = 'en';

type LocaleCatalog = { messages?: unknown } | null | undefined;
type ImportLocaleCatalog = (locale: string) => Promise<LocaleCatalog>;

const importLocaleCatalog: ImportLocaleCatalog = async (locale) => {
  try {
    return await import(`../locales/${locale}.po`);
  } catch {
    return null;
  }
};

const catalogMessages = (catalog: LocaleCatalog): Messages | null => {
  const messages = catalog?.messages;
  if (messages && typeof messages === 'object') {
    return messages as Messages;
  }
  return null;
};

const activateLocale = (locale: string, messages: Messages) => {
  i18n.load(locale, messages);
  i18n.activate(locale);
};

export const dynamicActivateLocale = async (locale: string, loadCatalog: ImportLocaleCatalog = importLocaleCatalog) => {
  try {
    const requestedMessages = catalogMessages(await loadCatalog(locale).catch(() => null));
    if (requestedMessages) {
      activateLocale(locale, requestedMessages);
      storage.local.setItem('locale', locale);
      return;
    }

    if (locale !== FALLBACK_LOCALE) {
      const fallbackMessages = catalogMessages(await loadCatalog(FALLBACK_LOCALE).catch(() => null));
      if (fallbackMessages) {
        activateLocale(FALLBACK_LOCALE, fallbackMessages);
        return;
      }
    }

    activateLocale(locale, {});
  } catch {
    activateLocale(locale, {});
  }
};
